// A referral's markup is either a percentage ("%") or a flat dollar amount ("$").
export const formatMarkup = (markup, markupType) => {
  if (markup === null || markup === undefined || markup === "") return "-";
  const value = Number(markup);
  if (Number.isNaN(value)) return "-";
  return markupType === "$" ? `$${value.toFixed(2)}` : `${value}%`;
};

// referral_balance is stored as a float, so a balance shown as $48.27 can really
// be 48.269999…, and the backend rejects any amount above the stored value.
// Returns the largest whole-cent amount that doesn't exceed the balance.
export const toWithdrawableAmount = (balance) => {
  const value = Number(balance);
  if (!Number.isFinite(value) || value <= 0) return 0;
  const cents = Math.round(value * 100);
  const amount = cents / 100;
  return amount > value ? (cents - 1) / 100 : amount;
};

export const isUsableReferral = (referral) =>
  !!referral &&
  referral.is_active !== false &&
  (!referral.expires_at || new Date(referral.expires_at).getTime() > Date.now());

// The referrals list comes newest first. Prefer the account's default referral,
// so creating a custom one doesn't swap the link people are already sharing.
export const pickPromoReferral = (referrals = []) =>
  referrals.find((r) => r?.referral_type === "default" && isUsableReferral(r)) ??
  referrals.find(isUsableReferral) ??
  null;

// Sign-up fails with one of the backend's "Referral code …" messages when the
// code can't be used (invalid, inactive, expired).
export const isReferralCodeError = (message) =>
  /referral code/i.test(message ?? "");
